export const BlobStorageBaseUrl = 'https://avitrucdn2.azureedge.net'
export const KnowledgepointSubPath = 'knowledgepoint'
